module.exports = __webpack_public_path__ + "static/media/banner-home.c423d178.svg";